import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { logRequest } from 'app/main/shared/http-utils';
import { User } from '../model/user.model';

@Injectable({ providedIn: 'root' })
export class AccountService {
    constructor(private http: HttpClient) {}

    get(): Observable<HttpResponse<User>> {
        return this.http.get<User>('uaa/api/account', {
            observe: 'response',
        });
    }

    save(account: User): Observable<HttpResponse<User>> {
        return this.http.post('uaa/api/account', account, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    passwordChange(currentPassword: string, newPassword: string): Observable<HttpResponse<any>> {
        return this.http.post(
            'uaa/api/account/change-password',
            {
                currentPassword,
                newPassword,
            },
            {
                observe: 'response',
                headers: logRequest(),
            }
        );
    }

    changeActiveTenant(
        username: string,
        sourceTenantId: string,
        targetTenantId: string
    ): Observable<HttpResponse<any>> {
        return this.http.post(
            'uaa/api/account/change-active-tenant',
            {
                username,
                sourceTenantId,
                targetTenantId,
            },
            {
                observe: 'response',
            }
        );
    }

    blockUser(userId: string): Observable<HttpResponse<any>> {
        return this.http.get<any>(`uaa/api/users/block-user/${userId}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    blockUserSendMessage(id: string): Observable<HttpResponse<any>> {
        return this.http.get<any>(`auth/send-message/block-user/${id}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }
}
